import { ClientEntitySelectService } from './client-entity-select/client-entity-select.service';
import { NameValueMapper } from 'src/app/services/mapper/name-value-mapper.';
import { KiwiSaverRedirectService } from './utils/kiwisaver-redirect.service';
import { ClientKiwiSaverGuard } from './guards/client-kiwisaver.guard';
import { RegisterAuthGuard } from './guards/register-auth.guard';
import { ClientHomeRouteService } from './utils/client-home-route.service';
import { RegistrationGuard } from './guards/registration.guard';
import { FeatureGuardService } from './guards/feature.guard';
import { FeatureToggleService } from './feature-toggle/feature-toggle.service';
import { FeatureFlagsService } from './feature-flags/feature-flags.service';
import { PlannedPortfoliosService } from './http/planned-portfolios.service';
import { ModelPortfoliosService } from 'src/app/services/http/model-portfolios.service';
import { CurrencyService } from './utils/currency.service';
import { PerformanceExcelReportService } from './export/performance-excel-report.service';
import { CashflowExcelReportService } from './export/cashflow-excel-report.service';
import { HoldingsExcelReportService } from './export/holdings-excel-report.service';
import { CashflowService } from './http/cashflow.service';
import { PerformanceService } from './http/performance.service';
import { DollarValuePipe } from '../utils/dollar-value.pipe';
import { PercentagePipe } from 'src/app/utils/percentage.pipe';
import { ClientService } from './http/client.service';
import { HoldingsService } from './http/holdings.service';
import { UserService } from './http/user.service';
import { AdministratorGuard } from './guards/advisor.guard';
import { ClientGuard } from './guards/client.guard';
import { AuthService } from './http/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { PortfoliosService } from './http/portfolios.service';
import { RegisterService } from './http/register.service';
import { TokenService } from './token/token.service';
import { TransactionsService } from './http/transactions.services';
import { ModuleGuard } from 'src/app/services/guards/module.guard';
import { UtilitiesService } from './http/utilities.service';
import { InvestorService } from './http/investor.service';
import { ReportsService } from './http/reports.service';
import { TradingService } from './http/trading.service';
import { RegularInvestmentPlanService } from './utils/regular-investment-plan.service';
import { CustomDatePipe } from 'src/app/utils/custom-date.pipe';
import { DocumentLibraryService } from './http/document-library.service';
import { PermissionGuard } from './guards/permission.guard';
import { PermissionsService } from './http/permission.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { WithdrawalsService } from './http/withdrawals.service';
import { GoogleAnalyticsService } from './google-tag-manager/google-analytics.service';
import { KiwiSaverGuard } from './guards/kiwisaver.guard';
import { BankAccountService } from './http/bank-account.service';
import { BuySellGuard } from './guards/buysell.guard';
import { RateCardService } from "./http/rate-card.service";
import { ReinvestmentService } from "./http/reinvestment.service";
import { UserRelationshipService } from "./http/user-relationship.service";

@NgModule({
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        JwtHelperService,
        AuthGuard,
        RegisterAuthGuard,
        AuthService,
        ClientGuard,
        ClientKiwiSaverGuard,
        AdministratorGuard,
        ModuleGuard,
        PermissionGuard,
        FeatureGuardService,
        RegistrationGuard,
        KiwiSaverGuard,
        BuySellGuard,
        UserService,
        UserRelationshipService,
        HoldingsService,
        PermissionsService,
        ClientService,
        UtilitiesService,
        DecimalPipe,
        PercentagePipe,
        DollarValuePipe,
        CurrencyPipe,
        CustomDatePipe,
        DatePipe,
        PerformanceService,
        CashflowService,
        HoldingsExcelReportService,
        CashflowExcelReportService,
        PerformanceExcelReportService,
        RegularInvestmentPlanService,
        ModelPortfoliosService,
        PlannedPortfoliosService,
        PortfoliosService,
        RegisterService,
        CurrencyService,
        TokenService,
        TransactionsService,
        ReportsService,
        FeatureToggleService,
        FeatureFlagsService,
        InvestorService,
        TradingService,
        DocumentLibraryService,
        ClientHomeRouteService,
        KiwiSaverRedirectService,
        ClientEntitySelectService,
        NameValueMapper,
        WithdrawalsService,
        ReinvestmentService,
        GoogleAnalyticsService,
        BankAccountService,
        RateCardService,
        UserRelationshipService,
        ReinvestmentService,
    ]
})
export class RootServiceModule {}
